// @flow
import * as React from 'react';
import styled from 'styled-components';
import map from 'lodash/map';
// import { SocialLink } from '../../../components';
import { TeamUserAvatar, TeamUserAvatarWrapper, TeamName } from '../../../components';
import { Select } from '../../../components/Form';
// import Facebook from '../../../components/Icons/Facebook';
// import Twitter from '../../../components/Icons/Twitter';
import colors from '../../../assets/css/colors';
import { below } from '../../../assets/css/media';

const TeamHeaderStyled = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: 10px auto;
	padding: 19px 0;

	${below.desktop`
		margin: 5px auto;
		padding: 2px 5px;
	`}
`;

const SelectWrapper = styled.div`
	width: 260px;
	${below.desktop`
		width: 37%;
	`}
	select {
		box-shadow: 0 0 8px 2px rgba(0,0,0,0.15);
		color: ${colors.title};
		font-size: 12px;
		font-weight: bold;
		letter-spacing: 0.5px;
		line-height: 1.5;
		padding: 0 2em 0 1em;
	}
`;

// const BorderedThinIconStyled = styled(SocialLink)`
// 	margin: 0 .25em;
// `;

type Props = {
	teams_by_id: Object,
	selected_team: Object,
	handleChange: Function,
	team_players_count: Object,
	team_ids: Array<number>
};

export const TeamHeader = (
	{ selected_team, teams_by_id, handleChange, team_players_count: count, team_ids }: Props
) => (
	<TeamHeaderStyled>
		<TeamUserAvatarWrapper>
			<TeamUserAvatar user_id={selected_team.user_id}
				avatar_version={selected_team.avatar_version} />
			<TeamName>{selected_team.name}</TeamName>
			<p>
				{count ? `(${count.current} / ${count.total})` : ''}
			</p>
			{/*Commented due to following ticket:*/}
			{/*https://fanhub.atlassian.net/browse/NRLDRAFT-531*/}
			{/*<BorderedThinIconStyled*/}
			{/*target="_blank"*/}
			{/*aria-label="Follow"*/}
			{/*className="hidden-mobile"*/}
			{/*border_color={colors.nrlDarkGreen}*/}
			{/*>*/}
			{/*<Facebook size="1.2" />*/}
			{/*</BorderedThinIconStyled>*/}
			{/*<BorderedThinIconStyled*/}
			{/*target="_blank"*/}
			{/*aria-label="Twitter"*/}
			{/*className="hidden-mobile"*/}
			{/*border_color={colors.nrlDarkGreen}*/}
			{/*>*/}
			{/*<Twitter size="1.2" />*/}
			{/*</BorderedThinIconStyled>*/}
		</TeamUserAvatarWrapper>
		<SelectWrapper>
			<Select name="teams" onChange={handleChange} value={selected_team.id}>
				{map(team_ids, id => (
					<option value={id}
						key={id}
					>
						{teams_by_id[id].name}
					</option>
				))}
			</Select>
		</SelectWrapper>
	</TeamHeaderStyled>
);

export default TeamHeader;


// WEBPACK FOOTER //
// ./src/pages/league/team/teamHeader.js